import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import { PharmaciesFiltersContext } from '../../../../context/PharmaciesFiltersContext'
import ChartBar from '../../../../components/charts/ChartBar'
import ChartBarSkeleton from '../../../../components/skeletons/ChartBarSkeleton'
import { ChartBarThemes } from '../../../../components/charts/types/ChartBar'
import { STATUS_CANCELLED } from '../../../../types/Order'

const GET_PHARMACIES_TOP_CANCELLATION_OUT_OF_STOCK = gql`
  query PharmaciesTopCancellationOutOfStock($filters: JSON) {
    ordersAggs(
      filters: $filters,
      size: 0,
      query: {
        bool: {
          filter: [
            {
              term: {
                status_translate_keyword: {
                  value: "${STATUS_CANCELLED}"
                }
              }
            },
            {
              term: {
                cancellation_reason_translate_keyword: "Produto sem estoque"
              }
            }
          ]
        }
      },
      aggs: {
        names: {
          terms: {
            field: "pharmacy_name.keyword",
            size: 30
          },
          aggs: {
            cnpjs: {
              terms: {
                field: "pharmacy.cnpj.keyword",
                size: 30
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`
type CnpjBucket = {
  key: string
}

interface Bucket {
  key: string
  doc_count: number,
  cnpjs: {
    buckets: [CnpjBucket]
  }
}
const PharmaciesTopCancellationOutOfStock = (): JSX.Element => {
  const { filters } = useContext(PharmaciesFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_PHARMACIES_TOP_CANCELLATION_OUT_OF_STOCK, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartBarSkeleton />
  if (loading || !data) return <ChartBarSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.ordersAggs.aggregations.names
  const categories: Array<string> = []
  const seriesData: Array<number> = []
  buckets.map((bucket: Bucket) => {
    categories.push(`${bucket.key} - ${bucket.cnpjs.buckets[0].key}`)
    return seriesData.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'PharmaciesTopCancellationGaveUp'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    }
  }
  const series = [{
    name: 'Frete',
    data: seriesData
  }]

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography
      paragraph
      style={{ paddingLeft: '20px', paddingTop: '20px' }}
    >
      TOP 30 farmácias com maior número de cancelamentos por falta de estoque
    </Typography>
    <ChartBar options={options} series={series} theme={ChartBarThemes.red} height={1024} />
  </Paper>
}

export default PharmaciesTopCancellationOutOfStock
